<template>
  <div>
    <bfheader></bfheader>
    <div class="main-content mt-2">
      <div class="header">
        <b-alert variant="info" :show="message != null">{{message}}</b-alert>
        <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
      </div>
      <div class="container-fluid">
        <div class="p-2 border-bottom border-info">
          <h4 class="text-info font-italic">
            <strong>FeliCaカード一覧</strong>
            <span class="ml-2"><b-btn variant="info" @click="loadItems"><i class="fas fa-sync"/> 再読込</b-btn></span>
          </h4>
        </div>
        <div>
          <v-client-table :columns="table.columns" :data="users" :options="table.options" class="users-table">
            <a slot="userGroup" slot-scope="props">
              <span v-if="props.row.userGroup"><b>({{props.row.groupId}}) {{props.row.userGroup.name}}</b></span>
              <span v-else><b>({{props.row.groupId}}) 未登録カード</b></span>
            </a>
            <a slot="member" slot-scope="props">
              <span v-if="!props.row.userNo || props.row.user_id === '0'"><b class="text-danger">未設定</b></span>
              <span v-else><b>ID番号:{{props.row.userNo}}</b></span>
            </a>
            <a slot="lastModifiedAt" slot-scope="props">
              {{ formatDateTime(props.row.lastModifiedAt) }}
            </a>
            <a slot="btns" slot-scope="props">
              <b-btn size="sm" variant="danger" @click="onDelete(props.row)">削除</b-btn>
            </a>
          </v-client-table>
        </div>
      </div>
    </div>

    <bffooter></bffooter>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'
import Vue from 'vue'
import moment from 'moment-timezone'
import { ClientTable } from 'vue-tables-2'

import bfheader from '@/components/BfHeader'
import bffooter from '@/components/BfFooter'

const logger = new Logger('UserFelicas')
Vue.use(ClientTable)

export default {
  name: 'UserFelicas',
  components: {
    bfheader,
    bffooter
  },
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      users: this.$store.getters.users,
      currentUser: {},
      table: {
        columns: [
          'idm', 'name', 'userGroup', 'member', 'lastModifiedAt', 'btns'
        ],
        options: {
          headings: {
            idm: 'FelicaIDM',
            name: 'カード名',
            userGroup: '使用測定会',
            member: '測定待ち参加者',
            lastModifiedAt: '更新日時',
            btns: '操作'
          }
        }
      }
    }
  },
  mounted: function () {
    this.loadItems()
  },
  methods: {
    formatDate (time) {
      return moment(time, 'x').format('YY/MM/DD HH:mm')
    },
    formatDateTime (time) {
      return moment(time, 'x').format('YY/MM/DD HH:mm:ss')
    },
    loadItems () {
      this.message = null
      this.error = null
      return new Promise((resolve) => {
        setTimeout(() => {
          return this.$store.dispatch('fetchUserFelicas').then((users) => {
            logger.debug('found users:', users)
            this.users = users
          }).catch(err => {
            logger.error(err)
            this.error = err.message || err
          })
        }, 1000)
      })
    },
    onDelete (userFelica) {
      this.message = null
      this.error = null
      return this.$store.dispatch('deleteUserFelica', { idm: userFelica.idm }).then(() => {
        this.message = '削除しました'
        this.loadItems()
      }).catch(err => {
        logger.error(err)
        this.error = err.message || err
      })
    }
  }
}
</script>

<style scoped>
.step-table, .users-table {
  font-size: 0.75rem;
}
</style>
